var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1687 19.1523L26.4303 6.43964C27.0718 5.13731 28.9287 5.13731 29.5701 6.43964L35.8317 19.1523L49.8572 21.1791C51.2935 21.3866 51.8676 23.1517 50.8282 24.1645L40.6839 34.0488L43.0787 48.0155C43.3239 49.4457 41.8222 50.5359 40.5383 49.8596L28.0002 43.2553L15.4621 49.8596C14.1777 50.5362 12.6754 49.4447 12.922 48.0141L15.3285 34.0488L5.17299 24.1652C4.13262 23.1527 4.70643 21.3867 6.14324 21.1791L20.1687 19.1523Z",
    fill: "#DDDFE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6aee763f0584adf94fa68547c8426261.svg";
export { ForwardRef as ReactComponent };